/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gettickets1Inputs */

const en_gettickets1 = /** @type {(inputs: Gettickets1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Tickets`)
};

const de_gettickets1 = /** @type {(inputs: Gettickets1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets kaufen`)
};

/**
* | output |
* | --- |
* | "Get Tickets" |
*
* @param {Gettickets1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const gettickets1 = /** @type {((inputs?: Gettickets1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gettickets1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gettickets1(inputs)
	return de_gettickets1(inputs)
});
export { gettickets1 as "getTickets" }